// src/services/perizinanIptService.js
import api from './api';

export const perizinanIptService = {
    // Setting
    getSetting: async () => {
        try {
            const response = await api.get('/perizinan-ipt-admin/setting');
            return { success: true, data: response.data?.data || response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil setting' };
        }
    },
    updateSetting: async (payload) => {
        try {
            const response = await api.post('/perizinan-ipt-admin/setting', payload);
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal menyimpan' };
        }
    },

    getPublic: async () => {
        try {
            const response = await api.get('/perizinan-ipt');
            return { success: true, data: response.data?.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    // Files
    getFiles: async () => {
        try {
            const response = await api.get('/perizinan-ipt-admin/files');
            return { success: true, data: response.data?.data || [] };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil file' };
        }
    },
    createFile: async (formData) => {
        try {
            const response = await api.post('/perizinan-ipt-admin/files', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal upload file' };
        }
    },
    updateFile: async (id, formData) => {
        try {
            const response = await api.post(`/perizinan-ipt-admin/files/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal update file' };
        }
    },
    deleteFile: async (id) => {
        try {
            await api.delete(`/perizinan-ipt-admin/files/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus file' };
        }
    },

    // FAQ
    getFaqs: async () => {
        try {
            const response = await api.get('/perizinan-ipt-admin/faqs');
            return { success: true, data: response.data?.data || [] };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil FAQ' };
        }
    },
    createFaq: async (payload) => {
        try {
            const response = await api.post('/perizinan-ipt-admin/faqs', payload);
            return { success: true, data: response.data?.data };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal menambah FAQ' };
        }
    },
    updateFaq: async (id, payload) => {
        try {
            const response = await api.put(`/perizinan-ipt-admin/faqs/${id}`, payload);
            return { success: true, data: response.data?.data };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal update FAQ' };
        }
    },
    deleteFaq: async (id) => {
        try {
            await api.delete(`/perizinan-ipt-admin/faqs/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus FAQ' };
        }
    },
    submitPermohonan: async (formData) => {
        try {
            const response = await api.post('/perizinan-ipt/submit', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return {
                success: true,
                data: response.data?.data,
                message: response.data?.message,
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengirim permohonan',
                errors: error.response?.data?.errors,
            };
        }
    },

    checkStatus: async (nomor_registrasi, nik) => {
        try {
            const response = await api.post('/perizinan-ipt/check-status', {
                nomor_registrasi,
                nik,
            });
            return { success: true, data: response.data?.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Data tidak ditemukan',
            };
        }
    },

    // Submissions (Admin)
    getSubmissions: async (params = {}) => {
        try {
            const response = await api.get('/perizinan-ipt-admin/submissions', { params });
            return { success: true, data: response.data?.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },
    getSubmissionStatistics: async () => {
        try {
            const response = await api.get('/perizinan-ipt-admin/submissions/statistics');
            return { success: true, data: response.data?.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil statistik' };
        }
    },
    getSubmissionDetail: async (id) => {
        try {
            const response = await api.get(`/perizinan-ipt-admin/submissions/${id}`);
            return { success: true, data: response.data?.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil detail' };
        }
    },
    updateSubmissionStatus: async (id, payload) => {
        try {
            const response = await api.post(`/perizinan-ipt-admin/submissions/${id}/status`, payload);
            return { success: true, data: response.data?.data, message: response.data?.message };
        } catch (error) {
            return { success: false, message: error.response?.data?.message || 'Gagal update status' };
        }
    },
    deleteSubmission: async (id) => {
        try {
            await api.delete(`/perizinan-ipt-admin/submissions/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },
    getSubmissionFileUrl: (id, index) => {
        const base = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        return `${base}/api/perizinan-ipt-admin/submissions/${id}/file/${index}`;
    },
};